const newWindow = (url) => {
  const newWin = window.open(url);
  if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
    alert('Please enable pop for this site');
  }
};

export { newWindow };
